<script setup lang="ts">

import {computed, defineProps} from "vue";
import {usePlanetStore} from "@/stores/planetStore";
import { useGameStore } from '@/stores/gameStore.ts'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Backend from '@/models/backend.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
const props = defineProps({
  planetId: {
    type: Number,
    required: true
  }
});

/**
 * Stores / models
 */
const planetStore = usePlanetStore()
const gameStore = useGameStore()

/**
 * Function
 */
const toggleAbandonPlanet = () => {

  if(planetData.value.abandon === 0) {
    gameStore.modal2Type = 'confirmationDelete';
    gameStore.modal2Data = {
      title: t('planets.abandon.confirmTitle'),
      message: t('planets.abandon.confirmMessage'),
      actionText: t('planets.abandon.yes'),
      cancelText: t('planets.abandon.no'),
      action: () => {
        const backend = new Backend();
        backend.abandonPlanet(props.planetId).then(() => {
          gameStore.setTinySuccessToastMessage(t('planets.abandon.setToAbandon'))
        })
      },
    };
  } else {
    const backend = new Backend();
    backend.abandonPlanet(props.planetId).then(() => {
      gameStore.setTinySuccessToastMessage(t('planets.abandon.abandonStopped'))
    })
  }
}

/**
 * Computed
 */
const planetData = computed(() => planetStore.findPlanetById(props.planetId)!)


</script>

<template>
  <StandardCard :title="t('planets.abandon.title')" :help="t('planets.abandon.help')" top-padding="2">
  <div class="flex justify-evenly">
    <div v-if="planetData.abandon === 1" class="flex justify-center">
      <div class="p-2 rounded text-center flex flex-col">
        <div class="pb-3 text-slate-300">{{ t('planets.abandon.abandonmentTime') }}</div>
        <div class="text-2xl font-bold text-red-500">{{ t('planets.abandon.weeks', { count: planetData.population }) }}</div>
      </div>
    </div>
    <div class="flex items-center p-4">
      <ActionButton v-if="planetData.abandon === 0" @click="toggleAbandonPlanet">{{ t('planets.abandon.abandonPlanet') }}</ActionButton>
      <ActionButton v-if="planetData.abandon === 1" @click="toggleAbandonPlanet">{{ t('planets.abandon.stopAbandoning') }}</ActionButton>
    </div>
  </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>
